import { render, staticRenderFns } from "./to-be-reviewed.vue?vue&type=template&id=7170b7da&"
import script from "./to-be-reviewed.vue?vue&type=script&lang=js&"
export * from "./to-be-reviewed.vue?vue&type=script&lang=js&"
import style0 from "./to-be-reviewed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports